import { FormField, TextInput, TextInputProps } from 'zens-storybook'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  container: {
    minHeight: 110,
  },
  input: {
    maxWidth: 400,
  },
})

interface Props extends Omit<TextInputProps, 'error'> {
  error?: string
}
const Email = (props: Props) => {
  const { error, ...otherProps } = props
  const { t } = useTranslation()

  return (
    <FormField label={t('Email')} error={error} style={styles.container}>
      <TextInput
        placeholder={t('Enter your email here')}
        inputMode="email"
        autoCapitalize="none"
        error={!!error}
        style={styles.input}
        {...otherProps}
      />
    </FormField>
  )
}

export default Email
